export const addressList = [
  {
    id: "a1",
    name: "线路一 · 主站直达",
    host: "51heilian01.top",
    status: "available",
    statusText: "顺畅",
    latency: "0.4s",
    region: "香港节点",
    updated: "8 分钟前",
    hot: true,
  },
  {
    id: "a2",
    name: "线路二 · 备用入口",
    host: "51heilian02.top",
    status: "available",
    statusText: "顺畅",
    latency: "0.6s",
    region: "新加坡节点",
    updated: "12 分钟前",
    hot: false,
  },
  {
    id: "a3",
    name: "线路三 · 高速通道",
    host: "heilian-fast.com",
    status: "busy",
    statusText: "繁忙",
    latency: "1.8s",
    region: "日本节点",
    updated: "25 分钟前",
    hot: false,
  },
  {
    id: "a4",
    name: "线路四 · 移动优选",
    host: "hl-mobile.net",
    status: "available",
    statusText: "顺畅",
    latency: "0.5s",
    region: "国内加速",
    updated: "16 分钟前",
    hot: true,
  },
  {
    id: "a5",
    name: "线路五 · 老用户通道",
    host: "51heilian-old.cc",
    status: "maintain",
    statusText: "维护中",
    latency: "--",
    region: "--",
    updated: "1 小时前",
    hot: false,
  },
  {
    id: "a6",
    name: "线路六 · 海外专线",
    host: "heilian-global.io",
    status: "available",
    statusText: "顺畅",
    latency: "0.9s",
    region: "美西节点",
    updated: "20 分钟前",
    hot: false,
  },
];

export const entryChannels = [
  {
    id: "e1",
    icon: "ri-global-line",
    title: "网页直连入口",
    desc: "无需安装，选一条当前顺畅的线路直接打开，适合临时看瓜。",
    action: "复制主站地址",
    accent: "primary",
  },
  {
    id: "e2",
    icon: "ri-smartphone-line",
    title: "App 下载安装",
    desc: "安卓 / iOS 双端可选，装完自动记忆入口，走丢也能一键回到。",
    action: "查看安装方式",
    accent: "accent",
  },
  {
    id: "e3",
    icon: "ri-links-line",
    title: "备用线路合集",
    desc: "把 6 条线路一次性收藏，主站打不开时逐条切换不迷路。",
    action: "查看全部线路",
    accent: "secondary",
  },
];

export const accessSteps = [
  {
    id: "s1",
    step: "01",
    title: "挑一条可用线路",
    desc: "先看下方「线路状态」表，优先选延迟低、状态为「顺畅」的那条。",
  },
  {
    id: "s2",
    step: "02",
    title: "复制或直接打开",
    desc: "点击复制把地址发到浏览器，或直接在 App 里打开，省去手动输入。",
  },
  {
    id: "s3",
    step: "03",
    title: "收藏本页防走丢",
    desc: "把本导航页加入书签，地址一有变动，回来刷新就能拿到最新可用入口。",
  },
];